/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recovery_Code_Instruction_1Inputs */



/**
* | output |
* | --- |
* | "Store this code in a secure location (password manager, safe, etc.)" |
*
* @param {Auth_Recovery_Code_Instruction_1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recovery_code_instruction_1 = /** @type {((inputs?: Auth_Recovery_Code_Instruction_1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recovery_Code_Instruction_1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speichere diesen Code an einem sicheren Ort (Passwort-Manager, Tresor, etc.)")
	return /** @type {LocalizedString} */ ("Store this code in a secure location (password manager, safe, etc.)")
});